import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getDefaultMyWebsiteSettings, myWebsiteSettingsSlice } from 'store/slices/myWebsiteSettings';
import { useGetMyWebsitePublishedSettingsQuery } from 'common/schema/commonSchemaRemoteGraphqlQueries';
import useAppSelector from 'common/hooks/useAppSelector';
import { useShouldShowFeatureFlag } from 'common/features/FeatureFlag/hooks/useFeatureFlag';
import { getCDNImageUrl } from 'utils/CDNImages';
import { getCustomizationsDeserialized } from '../utils/utilFunctions';

export const useGetMyWebsitePublishedSettings = (artistHandle: string, profileId?: number): void => {
  const state = useAppSelector((store) => store.myWebsiteSettings.state);
  const [isMyWebsiteActive] = useShouldShowFeatureFlag('myWebsite');

  const dispatch = useDispatch();

  useEffect(() => {
    if (!isMyWebsiteActive) {
      return;
    }
    dispatch(myWebsiteSettingsSlice.actions.SET_APPLY_MY_WEBSITE_SETTINGS(true));
  }, [isMyWebsiteActive]);

  useGetMyWebsitePublishedSettingsQuery({
    variables: { artistHandle },
    fetchPolicy: 'network-only',
    skip: !artistHandle || state === 'LOADED' || !profileId,
    onCompleted(data) {
      const myWebsiteData = data?.My_Website_Settings?.[0];
      const publishedSettings = myWebsiteData?.published_settings;

      if (!publishedSettings) {
        dispatch(
          myWebsiteSettingsSlice.actions.SET_MY_WEBSITE_INITIAL_SETTINGS({
            ...getDefaultMyWebsiteSettings(),
            state: 'LOADED',
          })
        );
        return;
      }

      const customizationOptions = getCustomizationsDeserialized(publishedSettings);

      dispatch(
        myWebsiteSettingsSlice.actions.SET_MY_WEBSITE_INITIAL_SETTINGS({
          ...customizationOptions,
          profileIcon: myWebsiteData?.profile_icon
            ? getCDNImageUrl({
                target: 'MyWebsite',
                purpose: 'ProfileIcon',
                targetId: profileId ?? 0,
                fileId: myWebsiteData.profile_icon,
                meta: {
                  size: 'large',
                },
              })
            : '',
          coverImage: myWebsiteData?.cover_image || undefined,
          mobileCoverImage: myWebsiteData?.mobile_cover_image || undefined,
        })
      );
    },
  });
};
